import { createClient } from '@supabase/supabase-js';

// Main active project credentials
const SUPABASE_URL = "https://nkqgoezzzciksagqueyt.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5rcWdvZXp6emNpa3NhZ3F1ZXl0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE3NTE0ODUsImV4cCI6MjA2NzMyNzQ4NX0.fwcjE5lML_iP9VNXnSDNQS9DJcV_ZOkEOO60eVfCt7U";
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Type definitions for better TypeScript support
export type Subscription = {
  id: string;
  email: string;
  created_at: string;
};